import { inject, Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ClubService {
  private _apiService: ApiService = inject(ApiService);

  constructor() { }

  searchClub(query: string, sportType: any): Observable<any> {
    return this._apiService.get(`/teams/club-list/?name=${query}&sport_type=${sportType}&limit=20`, );
  }
}
